module.exports = __webpack_public_path__ + "static/10-6ef542e3a532e2174acc620d6f77b0fb.jpg";